<template>
    <div>
        <v-title title="资料审核" style="margin-left: -15px"></v-title>
        <v-radio-group class="mt10" :list="actions" :value="currAction" @change="actionChange"></v-radio-group>
        <el-form ref="form" :model="form" :disabled="readonly" label-width="100px" label-position="left"
                 class="mt15" size="mini">
            <template v-if="currAction==='安排转诊'">
                <v-title title="转诊安排" style="margin-left: -15px"></v-title>
                        <el-form-item label="安排转诊医院" class="marginBottom">
                            <el-select v-model="form.acceptHosId" placeholder="转诊医院" @change="acceptHosIdChange"
                                       v-if="readonly===false" style="width:100% !important;">
                                <el-option v-for="(item,index) in acceptHosIds" :key="index" :label="item.hosName"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                            <el-input v-model="form.acceptHosName" v-else></el-input>
                        </el-form-item>
                 <el-row>
                        <el-col :span="11">
                            <el-form-item label="安排转诊科室" class="marginBottom">
                                <el-select v-model="form.acceptDeptId" placeholder="转诊科室" @change="acceptDeptChange"
                                           v-if="readonly===false" style="width:100% !important;">
                                    <el-option v-for="(item,index) in acceptDeptIds" :key="index" :label="item.deptName"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-input v-model="form.acceptDeptName" v-else></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="安排转诊医生" class="marginBottom">
                                <el-select v-model="form.acceptDocId" placeholder="转诊医生" v-if="readonly===false">
                                    <el-option v-for="(item,index) in acceptDocIds" :key="index" :label="item.docName"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-input v-model="form.acceptDocName" v-else></el-input>
                            </el-form-item>
                        </el-col>
                </el-row>
                        <el-form-item label="安排转诊时间" class="marginBottom">
                            <el-date-picker v-model="form.acceptTime"  value-format="yyyy-MM-dd HH:mm:ss"
                                            type="datetime"
                                            placeholder="选择日期"
                                            style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="医生备注" class="marginBottom">
                            <v-textarea v-model="form.remark" placeholder="例如：请补充患者X光片、检验报告等图片"></v-textarea>
                        </el-form-item>
            </template>
            <el-row v-if="currAction==='资料缺失'">
                <el-col :span="24">
                    <el-form-item label="" label-width="0px" class="marginBottom">
                        <v-textarea v-model="form.perfectReason" placeholder="例如：请补充患者X光片、检验报告等图片"></v-textarea>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="currAction==='拒绝转诊'">
                <el-col :span="24">
                    <el-form-item label="" label-width="0px" class="marginBottom">
                        <v-textarea v-model="form.refuseReason" placeholder="请输入拒绝理由"></v-textarea>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<style scoped lang="scss">
    @import "../../styles/hos";
</style>
<script>
  import VTitle from "../common/v-title";
  import VRadioGroup from "../common/v-radio-group";
  import {systemService} from "../../lib/service/system";
  import {isEmpty} from "../../lib/utils";
  import VTextarea from "../common/v-textarea";

  // const ACTIONS = ['资料就绪', '资料缺失', '拒绝转诊'];
   const ACTIONS = ['安排转诊', '拒绝转诊'];

  export default {
    name: "referral-check-form",
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
    },
    data() {
      let data = {}, form = {};
      ['accept'].forEach(r => {
        ['Hos', 'Dept', 'Doc'].forEach(rr => {
          data = {...data, ...{[`${r}${rr}Ids`]: []}};
          form = {...form, ...{[`${r}${rr}Id`]: ''}};
        })
      });
      return {
        ...data,
        currAction: '安排转诊',
        actions: [...ACTIONS].map(r => {
          return {
            label: r,
            value: r
          }
        }),
        form: {
          ...form,
          date: '',
          time: ''
        }
      }
    },
    components: {VTextarea, VRadioGroup, VTitle},
    created() {
      this.getHosList();
    },
    watch: {
      currAction(newV) {
        this.$emit('currActionChange', newV);
      }
    },
    methods: {
      getForm() {
        return {...this.form, action: this.currAction};
      },
      setForm(key, value) {
        this.$set(this.form, key, value);
      },
      actionChange(data) {
        this.currAction = data.value;
      },
      async getHosList() {
        const {doc} = this.loginInfo;
        this.acceptHosIds = [
          {hosName: doc.hosName, id: doc.hosId}
        ];
      },
      async acceptHosIdChange(val) {
        this.acceptDeptIds = await systemService.deptList(val);
        // const deptId = this.acceptDeptIds[0];
        // this.form.acceptDeptId = isEmpty(deptId) ? '' : deptId.id;
      },
      async acceptDeptChange(val) {
        const list = await systemService.docList(val);
        const docId = list[0];
        this.acceptDocIds = list;
        this.form.acceptDocId = isEmpty(docId) ? '' : docId.id;
      }
    },
  }
</script>
